module.exports = __webpack_public_path__ + "img/france-diabetes-mellitus-male.8225ca6c.png";